module.exports = __webpack_public_path__ + "assets/img/44@3x.efdfed07.png";